// extracted by mini-css-extract-plugin
export var menuIcon = "_s5-0";
export var menuIconInline = "_s5-1";